import { babyPortalApi } from 'data/axios';
import { UserResponseType } from 'typings/userTypes';
import { ApiResponse } from './HttpRequest';
import { endpoints } from './endpoints';

export async function GetUserDetails(): Promise<ApiResponse<UserResponseType>> {
  const response = await babyPortalApi.get('/api/v1/parents');
  return response.data;
}

type DeleteAccountPayload = {
  email: string;
};

export async function deleteAccountServices(
  payload: DeleteAccountPayload,
  partnerName: string
) {
  const response = await babyPortalApi.delete(endpoints.requestAccountDelete, {
    headers: {
      'Partner-ID': partnerName,
      'Client-ID': 'web',
      'skip-auth': true
    },
    data: payload
  });
  return response;
}
